import { render, staticRenderFns } from "./Poomsaevideos.vue?vue&type=template&id=0e544d98&scoped=true&"
import script from "./Poomsaevideos.vue?vue&type=script&lang=js&"
export * from "./Poomsaevideos.vue?vue&type=script&lang=js&"
import style0 from "./Poomsaevideos.vue?vue&type=style&index=0&id=0e544d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e544d98",
  null
  
)

export default component.exports